<template>
	<div class="connected-educations" v-if="currentPage && currentPageID && loadingPostsStatus === 'success' && postItems.length">
        <h2 class="titler">{{pageTitle}}</h2>
        <div class="resultats" v-if="loadingPostsStatus === 'success' && postItems.length">
            <Button v-for="edu in postItems" type="darkLight" :key="edu.id" uppercase hasIcon link :aria-label="edu.title">
                <WpLink :title="edu.title" :url="edu.link" v-html="edu.title"/>
            </Button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { arrow } from '@/components/../icons';
import Button from '@/components/elements/Button'
import WpLink from '@/components/elements/WpLink'

export default {
    name: 'connected-educations',
    data(){
        return {
            postItems: [],
            loadingPostsStatus: 'loading',
        }
    },
    components:{
        Button,
        WpLink
    },
    mounted(){
        const VM = this;

        VM.loadingPostsStatus = 'loading'
        if(!VM.currentPage) return false;

        if(VM.currentPostType === 'professions' && VM.currentPage.acf && VM.currentPage.acf.educations){
            VM.loadProffesionBased()
        }
        if(VM.currentPostType === 'educations' ){
            VM.loadEducationBased()
        }
        if(VM.currentPostType === 'ambassadors' ){
            VM.loadAmbassadorsBased()
        }
    },
    computed: {
        ...mapGetters([
            'currentPage',
            'isFrontPage',
            'currentPostType',
            'currentPageID'
        ]),
        pageTitle(){
            let title = 'Utdanning';
            switch (this.currentPostType) {
                case 'educations':
                    title = 'Yrkesalternativer'
                    break;
                case 'ambassadors':
                    title = 'Relatert innhold'
                    break;
            }

            return title;
        },
        arrowIcon(){
            return arrow('#00344D')
        },
        loadOptProf(){
            const VM = this;
            const opt = {
                type: 'educations',
                limit : this.currentPage.acf.educations.length,
                include : this.currentPage.acf.educations
            }

            return opt;
        },
        loadOptEdu(){
            const VM = this;
            const opt = {
                type: 'professions',
                limit : 30,
                meta : 'related_educations',
                value : VM.currentPageID
            }

            return opt;
        },

        loadOptAmba(){
            const VM = this;
            const opt = {
                type: 'educations',
                limit : 30,
                meta : 'ambassador',
                value : VM.currentPageID
            }

            return opt;
        }
    },
    methods:{
        ...mapActions([
            'getPost',
            'getMetaRelated'
        ]),
        actionOnResolved(res){
            const VM = this;

            if(res.data && res.data.posts && res.data.posts.length){
                VM.loadingPostsStatus = 'success'
                VM.postItems = res.data.posts
            }else{
                VM.loadingPostsStatus = 'notFound'  
            }
        },

        loadAmbassadorsBased(){
            const VM = this;
            VM.getMetaRelated(VM.loadOptAmba).then(res=>{
                VM.actionOnResolved(res)
            })  
        },

        loadEducationBased(){
            const VM = this;
            VM.getMetaRelated(VM.loadOptEdu).then(res=>{
                VM.actionOnResolved(res)
            })  
        },

        loadProffesionBased(){
            const VM = this;
            VM.getPost(VM.loadOptProf).then(res=>{
                VM.actionOnResolved(res)
            })  
        }
        
    }
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.connected-educations{
    max-width: 800px;
    .resultats{
        .fill-button{
            display: flex;
            width: 100%;
            margin-top: 10px;
            justify-content: space-between;
            .icon{
                margin-right: 25px;
            }
        }
    }
}
</style>
